import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiRoutes } from '../api/ApiRoutes';
import { Gt2ApiService } from '../api/gt2-api.service';

@Injectable({
  providedIn: 'root',
})
export class AssetUploadService {
  constructor(
    private http: HttpClient,
    private api: Gt2ApiService,
  ) {}

  public uploadAsset(
    file: File,
    assetType: string,
    entityUuid?: string,
  ): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('asset_type', assetType);
    if (entityUuid) {
      formData.append('entity_uuid', entityUuid);
    }
    return this.http.post<any>(
      this.api.createUrl(ApiRoutes.UPLOAD_ASSET),
      formData,
    );
  }
}
